var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlockAux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 81,
    viewBox: "0 0 79 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8996 0.945577L4.79957 13.3383C1.91365 14.4505 0 17.3104 0 20.488V56.2523C0 59.1439 1.58957 61.7813 4.08967 63.0683L36.1897 79.592C38.2731 80.6724 40.7269 80.6724 42.8103 79.592L74.9103 63.0683C77.4259 61.7813 79 59.128 79 56.2523V20.488C79 17.3104 77.0863 14.4664 74.2004 13.3542L42.1004 0.961465C40.4337 0.294163 38.5818 0.294163 36.8996 0.945577ZM39.5077 10.8121L69.1385 22.2516V22.4264L39.5077 34.8191L9.87693 22.4264V22.2516L39.5077 10.8121ZM44.4462 67.374V43.7165L69.1385 33.3892V54.6635L44.4462 67.374Z",
    fill: "#7163d0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockAux);
export default __webpack_public_path__ + "static/media/block-aux.f616a067.svg";
export { ForwardRef as ReactComponent };